import { useBackendApi } from './backendApi';
import { useEventsPublisher, useEventsSubscriber } from 'event-bus';
import { TasksGroup } from './tasksGroupsService';

export interface TasksGroupRequest {
  name: string;
  color: string | null;
}


export const TASKS_GROUPS_ADMIN_UPDATED = 'TASKS_GROUPS_ADMIN_UPDATED';

export function useTasksGroupsAdminService() {
  const nekstApi = useBackendApi();
  const eventsPublisher = useEventsPublisher();

  useEventsSubscriber('tasksGroupsAdminService', {
    [TASKS_GROUPS_ADMIN_UPDATED]: () => {
      // Cache cleared event - no cache to clear
    }
  }, []);

  const createTasksGroup = async (request: TasksGroupRequest): Promise<TasksGroup> => {
    const response = await nekstApi.post('/manager/tasksgroups', request) as TasksGroup;
    eventsPublisher.publish(TASKS_GROUPS_ADMIN_UPDATED, {});
    return response;
  };

  const getTasksGroups = async (): Promise<TasksGroup[]> => {
    return await nekstApi.get('/manager/tasksgroups') as TasksGroup[];
  };

  const updateTasksGroup = async (tasksGroupId: number, request: TasksGroupRequest): Promise<TasksGroup> => {
    const response = await nekstApi.put(`/manager/tasksgroups/${tasksGroupId}`, request) as TasksGroup;
    eventsPublisher.publish(TASKS_GROUPS_ADMIN_UPDATED, {});
    return response;
  };

  const deleteTasksGroup = async (tasksGroupId: number): Promise<void> => {
    await nekstApi.delete(`/manager/tasksgroups/${tasksGroupId}`);
    eventsPublisher.publish(TASKS_GROUPS_ADMIN_UPDATED, {});
  };

  return {
    createTasksGroup,
    getTasksGroups,
    updateTasksGroup,
    deleteTasksGroup,
  };
}
